"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLTableRowSelector = void 0;
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useSelection_1 = __importDefault(require("@opsbase/web-data-selection/useSelection"));
const useSelectionActions_1 = __importDefault(require("@opsbase/web-data-selection/useSelectionActions"));
const Checkbox_1 = __importDefault(require("@opsbase/web-ui/Checkbox"));
const react_1 = __importStar(require("react"));
function DVLTableRowSelector(props) {
    var _a;
    const { nodeKey, item } = props;
    const dt = (0, useDataTree_1.default)();
    const { type: dataType } = (0, useView_1.default)(dt.viewId);
    const { selecteds } = (0, useSelection_1.default)(dataType);
    const { toggleSelection } = (0, useSelectionActions_1.default)(dataType);
    const node = dt.nodesByKey.get(nodeKey);
    const isSingleItem = !!item;
    const items = (0, react_1.useMemo)(() => { var _a; return (isSingleItem ? [item] : ((_a = node === null || node === void 0 ? void 0 : node.itemCollection) === null || _a === void 0 ? void 0 : _a.items) || []); }, [isSingleItem, item, (_a = node === null || node === void 0 ? void 0 : node.itemCollection) === null || _a === void 0 ? void 0 : _a.items]);
    const numItems = items.length;
    const selectedIds = new Set(selecteds.map(si => si.id));
    const selectedItems = items.filter(theItem => selectedIds.has(theItem.id));
    const numSelectedItems = selectedItems.length;
    const disabled = numItems === 0;
    const checked = numSelectedItems === numItems && numItems > 0;
    const partChecked = !checked && numSelectedItems > 0 && numItems > 0;
    const handleToggle = (0, react_1.useCallback)(onOff => {
        toggleSelection(items, onOff);
    }, [items, toggleSelection]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(Checkbox_1.default, { small: true, disabled: disabled, partChecked: partChecked, checked: checked, onChange: handleToggle })), [disabled, partChecked, checked, handleToggle]);
}
exports.DVLTableRowSelector = DVLTableRowSelector;
exports.default = DVLTableRowSelector;
